// extracted by mini-css-extract-plugin
export default {"container":"ScopeList_container__4juqi","userName":"ScopeList_userName__dK-u7"};